import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

import { getPaletteColor, IconButton } from 'pcln-design-system'
import { ArrowUp } from 'pcln-icons'
import throttle from 'lodash/throttle'

function getResponsiveContainerStyles(props) {
  return `
  ${props.theme.flyQueries.tablet} {
    margin-right: -15px;
  }

  ${props.theme.flyQueries.tablethd} {
    bottom: 0;
    right: 182px;
  }

  ${props.theme.flyQueries.desktoplg} {
    left: 50%;
    margin-left: 268px;
  }
  `
}

const Container = styled.div`
  bottom: 80px;
  cursor: pointer;
  height: 80px;
  margin-right: -20px;
  opacity: 1;
  position: fixed;
  right: 10px;
  transform: translatez(0);
  transition: opacity 200ms;
  width: 80px;
  z-index: 10;

  > button {
    background-color: ${getPaletteColor('primary.base')};

    &:hover {
      background-color: ${getPaletteColor('primary.dark')};
    }
  }

  ${(props) => getResponsiveContainerStyles(props)}
`

const CircleButton = styled(IconButton)`
  background-color: ${getPaletteColor('primary.base')};
  z-index: 2;
  position: absolute;
  margin: 16px;
  border-radius: 50%;
  width: 45px;
  height: 45px;
  text-align: center;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
  display: flex;
  justify-content: center;
  align-items: center;
  :hover {
    background-color: ${getPaletteColor('primary.dark')};
  }
`

export const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false)

  const handleScroll = () => {
    const scrollPosition = document.documentElement.scrollTop || window.scrollY
    setIsVisible(scrollPosition > 400)
  }

  useEffect(() => {
    const throttledHandler = throttle(handleScroll, 500)
    window.addEventListener('scroll', throttledHandler)
    return () => {
      window.removeEventListener('scroll', throttledHandler)
    }
  }, [])

  const scrollTop = () => {
    window.scrollTo(0, 0)
  }

  return isVisible ? (
    <Container data-testid='back-to-top-icon' data-back-to-top={isVisible}>
      <CircleButton
        aria-label='Back to top of listings'
        onClick={scrollTop}
        icon={<ArrowUp color='background.lightest' />}
      />
    </Container>
  ) : null
}
